/**
 * Slot → URL. Components never hard-code a file name; they ask for a slot.
 * The R2 manifest (ASSETS.md, scripts/process-assets.ts) replaces this map in
 * production by shipping config/assets.manifest.json; until then slots resolve
 * to the local processed copies under /assets/funnel.
 */
export interface AssetEntry { url: string; w?: number; h?: number }

let manifest: Record<string, AssetEntry> = {};
let version = 1;

export function setAssetManifest(next: Record<string, AssetEntry> | undefined, assetsVersion: number): void {
  manifest = next ?? {};
  version = assetsVersion;
}

export function asset(slot: string | undefined): string {
  if (!slot) return '';
  const entry = manifest[slot];
  if (entry) return entry.url;
  const base = slot === 'brand-icon' ? '/assets/logo-64.svg' : `/assets/funnel/${slot}.webp`;
  return version > 1 ? `${base}?v=${version}` : base;
}

export function preload(slots: (string | undefined)[]): void {
  for (const slot of slots) {
    const href = asset(slot);
    if (!href) continue;
    if (document.head.querySelector(`link[rel="preload"][href="${href}"]`)) continue;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = href;
    document.head.appendChild(link);
  }
}
